import { CustomRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { AsphaltMixDesign } from '../AsphaltMixDesignsContext/types'
import { Permission } from '@cims-online/shared'
import { useAsphaltMixDesignsContext } from '../AsphaltMixDesignsContext'

export function useCustom(): CustomRowActionOptions<AsphaltMixDesign>[] {
  const { edit, refetch } = useAsphaltMixDesignsContext()
  const setActive = async (globalId: string, active = true) => {
    await edit({ variables: { input: { globalId, active } } })
    refetch()
  }
  return [
    {
      permission: Permission.EditAsphaltMixDesign,
      text: 'Activate',
      onClick: async ({ globalId }) => setActive(globalId),
      hidden: ({ active }) => active,
    },
    {
      permission: Permission.EditAsphaltMixDesign,
      text: 'Inactivate',
      onClick: async ({ globalId }) => setActive(globalId, false),
      hidden: ({ active }) => !active,
    },
  ]
}
